import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { InlineEmployee } from 'modules/employees/components/InlineEmployee'

import type { Transfer } from './types'

export const Requester = ({ requester }: { requester: Transfer['requester'] }) => {
  if (!!requester) {
    return <InlineEmployee employee={requester} variant="medium" linkProfile />
  }
  return (
    <Box flexDirection="row" alignItems="center" gap="s16">
      <Avatar size="s40" label={i18n.t('banking.payments.unknown_person')} />
      <Text.Normal size="200">{i18n.t('banking.payments.unknown_person')}</Text.Normal>
    </Box>
  )
}
